import React from 'react'
import { getTrackBackground, Range } from 'react-range'

type props = { values: Array<number>; onChange: any }

function InputRange(props: props): any {
    const MIN = 0
    const MAX = 100
    const def = props
    return (
        <Range
            values={props.values}
            min={MIN}
            max={MAX}
            onChange={props.onChange}
            renderTrack={({ props, children }) => (
                <div
                    onMouseDown={props.onMouseDown}
                    onTouchStart={props.onTouchStart}
                    style={{
                        ...props.style,
                        height: '36px',
                        display: 'flex',
                        width: '100%',
                        borderRadius: '10px'
                    }}
                >
                    <div
                        ref={props.ref}
                        style={{
                            height: '15px',
                            width: '100%',
                            borderRadius: '10px',
                            border: '2px solid rgba(188, 224, 253, 1)',
                            background: getTrackBackground({
                                values: def.values,
                                colors: ['rgba(0, 159, 245, 1)', 'white'],
                                min: MIN,
                                max: MAX
                            }),
                            alignSelf: 'center'
                        }}
                    >
                        {children}
                    </div>
                </div>
            )}
            renderThumb={({ props }) => (
                <div
                    {...props}
                    style={{
                        position: 'absolute',
                        left: '1',
                        height: '0',
                        width: '0',
                        borderRadius: '10px',
                        backgroundColor: 'rgba(0, 159, 245, 1)',
                        outline: 'none'
                    }}
                />
            )}
        />
    )
}

export default InputRange
